import Cookies from "js-cookie";
import { cookieNames } from "./cookie-names";

export interface CookieSettings {
    /** Has the user hidden the cookies banner? */
    hasHiddenBanner?: boolean;
}

/**
 * Get any saved user cookie settings, if they are set
 */
export function getCookieSettings(): CookieSettings {
    const existingCookieControlCookie = Cookies.get(cookieNames.cookieSettings);
    return existingCookieControlCookie
        ? JSON.parse(existingCookieControlCookie) as CookieSettings
        : {};
}

/**
 * Save user cookie settings as a cookie
 */
export function setCookieSettings(cookieSettings: CookieSettings) {
    Cookies.set(cookieNames.cookieSettings, JSON.stringify(cookieSettings), { secure: true });
}

